import type { LibItemSysIcon } from '@types';

export const markerIconList: LibItemSysIcon[] = [
  { url: '/hotspots/system/map/point/a1.png', frame: 1 },
  { url: '/hotspots/system/map/point/a2.png', frame: 1 },
  { url: '/hotspots/system/map/point/a3.png', frame: 1 },
  { url: '/hotspots/system/map/point/a4.png', frame: 1 },
  { url: '/hotspots/system/map/point/a5.png', frame: 1 },
  { url: '/hotspots/system/map/point/a6.png', frame: 1 },
  { url: '/hotspots/system/map/point/a7.png', frame: 1 },
  { url: '/hotspots/system/map/point/a8.png', frame: 1 },
  { url: '/hotspots/system/map/point/a9.png', frame: 1 },
  { url: '/hotspots/system/map/point/a10.png', frame: 1 },
  { url: '/hotspots/system/map/point/b1.png', frame: 1 },
  { url: '/hotspots/system/map/point/b2.png', frame: 1 },
  { url: '/hotspots/system/map/point/b3.png', frame: 1 },
  { url: '/hotspots/system/map/point/b4.png', frame: 1 },
  { url: '/hotspots/system/map/point/b5.png', frame: 1 },
  { url: '/hotspots/system/map/point/b6.png', frame: 1 },
  { url: '/hotspots/system/map/point/b7.png', frame: 1 },
  { url: '/hotspots/system/map/point/b8.png', frame: 1 },
  { url: '/hotspots/system/map/point/b9.png', frame: 1 },
  { url: '/hotspots/system/map/point/b10.png', frame: 1 },
  { url: '/hotspots/system/map/point/b11.png', frame: 1 },
  { url: '/hotspots/system/map/point/c1.png', frame: 1 },
  { url: '/hotspots/system/map/point/c2.png', frame: 1 },
  { url: '/hotspots/system/map/point/c3.png', frame: 1 },
  { url: '/hotspots/system/map/point/c4.png', frame: 1 },
  { url: '/hotspots/system/map/point/c5.png', frame: 1 },
  { url: '/hotspots/system/map/point/c6.png', frame: 1 },
  { url: '/hotspots/system/map/point/c7.png', frame: 1 },
  { url: '/hotspots/system/map/point/c8.png', frame: 1 },
  { url: '/hotspots/system/map/point/c9.png', frame: 1 },
  { url: '/hotspots/system/map/point/c10.png', frame: 1 },
  { url: '/hotspots/system/map/point/c11.png', frame: 1 },
  { url: '/hotspots/system/map/point/c12.png', frame: 1 },
  { url: '/hotspots/system/map/point/d1.png', frame: 1 },
  { url: '/hotspots/system/map/point/d2.png', frame: 1 },
  { url: '/hotspots/system/map/point/d3.png', frame: 1 },
  { url: '/hotspots/system/map/point/d4.png', frame: 1 },
  { url: '/hotspots/system/map/point/d5.png', frame: 1 },
  { url: '/hotspots/system/map/point/d6.png', frame: 1 },
  { url: '/hotspots/system/map/point/d7.png', frame: 1 },
  { url: '/hotspots/system/map/point/d8.png', frame: 1 },
  { url: '/hotspots/system/map/point/d9.png', frame: 1 },
  { url: '/hotspots/system/map/point/d10.png', frame: 1 },
  { url: '/hotspots/system/map/point/e1.png', frame: 1 },
  { url: '/hotspots/system/map/point/e2.png', frame: 1 },
  { url: '/hotspots/system/map/point/e3.png', frame: 1 },
  { url: '/hotspots/system/map/point/e4.png', frame: 1 },
  { url: '/hotspots/system/map/point/e5.png', frame: 1 },
  { url: '/hotspots/system/map/point/e6.png', frame: 1 },
  { url: '/hotspots/system/map/point/e7.png', frame: 1 },
  { url: '/hotspots/system/map/point/e8.png', frame: 1 },
  { url: '/hotspots/system/map/point/e9.png', frame: 1 },
  { url: '/hotspots/system/map/point/e10.png', frame: 1 },
  { url: '/hotspots/system/map/point/e11.png', frame: 1 },
  { url: '/hotspots/system/map/point/e12.png', frame: 1 },
  { url: '/hotspots/system/map/point/f1.png', frame: 1 },
  { url: '/hotspots/system/map/point/f2.png', frame: 1 },
  { url: '/hotspots/system/map/point/f3.png', frame: 1 },
  { url: '/hotspots/system/map/point/f4.png', frame: 1 },
  { url: '/hotspots/system/map/point/f5.png', frame: 1 },
  { url: '/hotspots/system/map/point/f6.png', frame: 1 },
  { url: '/hotspots/system/map/point/f7.png', frame: 1 },
  { url: '/hotspots/system/map/point/f8.png', frame: 1 },
];
